import screensdataMutations from "./mutations.js";
import screensActions from "./actions.js";
import screensGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: screensdataMutations,
  actions: screensActions,
  getters: screensGetters,
};
